

export abstract class ChartConfigManager {
    abstract validate(config: any): boolean;
    abstract convert(config: any): any;
    abstract currentVersion(): string;
    abstract isCurrentVersion(config: any): boolean;
}
